// 商品库管理-商品基础库
import React, { PureComponent } from 'react';
import {
  Row,
  Col,
  Form,
  Button,
  Input,
  Table,
  Modal,
  Select,
  Divider,
  message,
  InputNumber,
  TreeSelect,
} from 'antd-v5';
import PageHeaderLayout from '../../../component/page-header-layout/index';
import moment from 'moment';
import './index.less';
import {
  getSpuCategoryTreeListRequest,
  getSpuCategoryPageRequest,
  addSpuCategoryRequest,
  deleteSpuCategoryRequest,
  updateSpuCategoryRequest,
} from '../../../state/request/cxmProductSpuCategory';
const { Column } = Table;
const { confirm } = Modal;
const LEVEL_OPTIONS = [
  { value: '', label: '全部' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
];
class CommodityCategory extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataSource: {},
      rows: {},
      visible: false,
      contentTitle: '',
      defaultCurrent: 1, //当前页
      searchValues: {},
      treeData: [],
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.getSpuCategoryPage();
    this.getSpuCategoryList();
  }

  // 获取商品基库列表
  async getSpuCategoryPage() {
    this.setState({ loading: true });
    const { defaultCurrent, searchValues } = this.state;
    const params = {
      ...searchValues,
      pageNo: defaultCurrent,
      pageSize: 10,
    };
    const res = await getSpuCategoryPageRequest(params);
    this.setState({ loading: false });
    if (res?.code === 200) {
      this.setState({ dataSource: res.data });
    }
  }

  getSpuCategoryList = async () => {
    const res = await getSpuCategoryTreeListRequest();
    if (res?.code === 200) {
      this.setState({ treeData: res.data });
    }
  };

  isUndefied = (value) => {
    return value || null;
  };

  // 查询
  handleSumbit = (values) => {
    this.setState(
      {
        defaultCurrent: 1,
        searchValues: values,
      },
      this.getSpuCategoryPage,
    );
  };
  // 重置
  handleReset = () => {
    this.formRef.current.resetFields();
    this.setState(
      {
        defaultCurrent: 1,
        searchValues: {},
      },
      this.getSpuCategoryPage,
    );
  };

  pageSwitch = (obj) => {
    this.setState(
      {
        defaultCurrent: obj.current,
      },
      this.getSpuCategoryPage,
    );
  };

  // 新增、编辑
  showGoodsModal = (rows, visible, title) => {
    this.setState({
      rows,
      visible,
      contentTitle: title,
    });
  };

  // 新增、编辑保存按钮
  editHandleSubmit = async (values) => {
    const { rows, defaultCurrent } = this.state;
    const params = {
      ...values,
    };
    if (rows.id) {
      params.id = rows.id;
    }
    const API = params.id ? updateSpuCategoryRequest : addSpuCategoryRequest;
    const res = await API(params);
    if (res.code === 200) {
      message.success(params.id ? '修改成功' : '保存成功');
      this.setState(
        {
          visible: false,
          defaultCurrent: params.id ? defaultCurrent : 1,
        },
        () => {
          this.getSpuCategoryPage();
          this.getSpuCategoryList();
        },
      );
    }
  };

  delete = (record) => {
    const that = this;
    confirm({
      title: '提示',
      content: `确定删除【${record.name}】该货品分类么？`,
      okText: '确认',
      cancelText: '取消',
      onOk() {
        that.deleteCommodity(record.id);
      },
      onCancel() {},
    });
  };

  async deleteCommodity(id) {
    const res = await deleteSpuCategoryRequest(id);
    if (res.code === 200) {
      message.success('删除成功');
      this.getSpuCategoryPage();
      this.getSpuCategoryList();
    }
  }
  // 转换后台数据为编辑弹窗 TreeSelect 所需格式（第三级节点禁用）
  convertToEditTreeData = (data) => {
    if (!Array.isArray(data)) return [];
    return data.map((item) => ({
      title: item.name,
      value: item.id,
      level: item.level,
      disabled: item.level === 3, // 第三级节点禁用选择
      children: this.convertToEditTreeData(item.childNodeList),
    }));
  };

  render() {
    const { loading, rows, visible, contentTitle, defaultCurrent, dataSource, treeData } =
      this.state;
    const { pageList = [], totalSize } = dataSource;
    const pagination = {
      pageSize: 10,
      total: totalSize,
      current: defaultCurrent,
      showSizeChanger: false,
    };
    return (
      <div className='commodity-index'>
        <PageHeaderLayout>
          <div className='commodityManage'>
            <Form
              ref={this.formRef}
              onFinish={this.handleSumbit}
              layout='inline'
              style={{ marginBottom: 12 }}
            >
              <Form.Item label='上级货品分类' name='parentId'>
                <TreeSelect
                  style={{ width: 150 }}
                  placeholder='请选择上级货品分类'
                  treeLine
                  treeDefaultExpandAll
                  allowClear
                  showSearch
                  treeData={this.convertToEditTreeData(treeData)}
                  filterTreeNode={(input, treeNode) => {
                    return treeNode.props.title.indexOf(input) >= 0;
                  }}
                />
              </Form.Item>
              <Form.Item label='分类级别' name='level'>
                <Select
                  style={{ width: 150 }}
                  placeholder='请选择分类级别'
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {LEVEL_OPTIONS.map((item, index) => (
                    <Select.Option key={index} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label='货品分类名称' name='name'>
                <Input style={{ width: 150 }} placeholder='请输入货品分类名称' allowClear />
              </Form.Item>
              <Form.Item>
                <Button type='primary' htmlType='submit'>
                  查询
                </Button>
                <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                  重置
                </Button>
                <Button
                  type='primary'
                  style={{ marginLeft: 8 }}
                  onClick={() => this.showGoodsModal({}, true, '新增货品分类')}
                >
                  新增货品分类
                </Button>
              </Form.Item>
            </Form>
            <Table
              rowKey={(_, index) => index}
              dataSource={pageList}
              pagination={pagination}
              bordered
              loading={loading}
              onChange={this.pageSwitch.bind(this)}
            >
              <Column title='货品分类ID' dataIndex='id' key='id' />
              <Column
                title='上级货品分类名称'
                dataIndex='parentName'
                key='parentName'
                render={(_, record) => {
                  return record.parentName || '--';
                }}
              />
              <Column title='货品分类名称' dataIndex='name' key='name' />
              <Column title='排序' dataIndex='sort' key='sort' />
              <Column title='分类级别' dataIndex='level' key='level' />
              <Column title='更新人' dataIndex='personName' key='personName' />
              <Column
                title='更新时间'
                dataIndex='updateTime'
                key='updateTime'
                render={(_, record) => {
                  return record.updateTime
                    ? moment(record.updateTime).format('YYYY-MM-DD HH:mm:ss')
                    : '';
                }}
              />
              <Column
                title='操作'
                dataIndex='option'
                key='option'
                width={150}
                render={(_, record) => {
                  return (
                    <div>
                      <a
                        href='/'
                        onClick={(e) => {
                          e.preventDefault();
                          this.showGoodsModal(record, true, '编辑货品分类');
                        }}
                      >
                        编辑
                      </a>
                      <Divider type='vertical' />
                      <a
                        href='/'
                        onClick={(e) => {
                          e.preventDefault();
                          this.delete(record);
                        }}
                      >
                        删除
                      </a>
                    </div>
                  );
                }}
              />
            </Table>
            {/** 新增货品、 修改货品 */}
            <Modal
              title={contentTitle}
              visible={visible}
              onCancel={() => this.showGoodsModal({}, false)}
              destroyOnClose
              width='600px'
              className='commodity-modal'
              footer={null}
            >
              <Form
                style={{ marginTop: 36 }}
                onFinish={this.editHandleSubmit}
                initialValues={{
                  name: rows.name,
                  parentId: rows.parentId || null,
                  sort: rows.sort,
                }}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 14 }}
              >
                <Form.Item label='上级货品分类' name='parentId'>
                  <TreeSelect
                    treeLine
                    treeDefaultExpandAll
                    allowClear
                    showSearch
                    treeData={this.convertToEditTreeData(treeData)}
                    filterTreeNode={(input, treeNode) => {
                      return treeNode.props.title.indexOf(input) >= 0;
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label='货品分类名称'
                  name='name'
                  rules={[
                    { required: true, message: '请输入货品分类名称' },
                    { type: 'string', min: 1, max: 10, message: '货品分类名称不超过10个字' },
                  ]}
                >
                  <Input placeholder='请输入货品分类名称' allowClear />
                </Form.Item>
                <Form.Item
                  label='排序'
                  name='sort'
                  rules={[
                    { required: true, message: '请输入排序' },
                    // { type: 'string', min: 1, max: 6, message: '排序不超过6位' },
                  ]}
                >
                  <InputNumber
                    precision={2}
                    style={{ width: '100%' }}
                    placeholder='请输入排序'
                    allowClear
                  />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 24 }}>
                  <Row gutter={10} style={{ textAlign: 'center' }}>
                    <Col span={24}>
                      <Button type='primary' htmlType='submit' style={{ width: 80 }}>
                        保存
                      </Button>
                      <Button
                        style={{ marginLeft: 25, width: 80 }}
                        onClick={() => this.showGoodsModal({}, false)}
                      >
                        取消
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form>
            </Modal>
          </div>
        </PageHeaderLayout>
      </div>
    );
  }
}

export default CommodityCategory;
